import restClient, {REST_CONFIG_WWW_FORM_URLENCODED} from './BackendRestClient';
import * as queryString from 'query-string';

export function login(userName, password) {
    const requestBody = {
        userName,
        password,
        userAgent: navigator.userAgent
    };
    return restClient.post(["auth", "login"].join("/"), queryString.stringify(requestBody), REST_CONFIG_WWW_FORM_URLENCODED)
        .then(res => res)
}

export function tokenLogin() {
    const requestBody = {
        userAgent: navigator.userAgent
    };
    return restClient.post(["auth", "token-login"].join("/"), queryString.stringify(requestBody), REST_CONFIG_WWW_FORM_URLENCODED)
        .then(res => res)
}

export function logout() {
    return restClient.post(["auth", "logout"].join("/"), {})
        .then(res => res)
}

export function register(user) {
    return restClient.post(["auth", "register"].join("/"), user)
        .then(res => res)
}

export function forgotPassword(userName, email) {
    const requestBody = {
        userName,
        email
    };
    return restClient.post(["auth", "forgot-password"].join("/"), queryString.stringify(requestBody), REST_CONFIG_WWW_FORM_URLENCODED)
        .then(res => res);
}